<template>
  <div>
    <HorizontalToggle v-if="screenWidth < 850">
      <div class="sliderBar" v-if="sliderStatus">
        <span class="scale icon-menu" @click="changeSliderStatus"></span>
        <div class="trustlook_logo">
          <img src="../assets/img/logo-trustlook.png" alt="" />
        </div>
        <el-menu
          class="el-menu-vertical-demo"
          :default-active="onRoutes"
          background-color="#1f263e"
          active-text-color="#ff6500"
          @open="handleOpen"
          @close="handleClose"
          :default-openeds="openeds"
          :collapse="isCollapse"
          router
        >
          <template v-for="(menu, index) in menuData">
            <el-submenu v-if="menu.subMenu" :key="index" :index="menu.index">
              <template slot="title">
                <i :class="menu.icon"></i>
                <span class="menu-name">{{ menu.menuName }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  :key="subIndex"
                  :index="subMenu.index"
                  v-for="(subMenu, subIndex) in menu.subMenu"
                  @click="openUrl(subMenu.path)"
                  :disabled="subMenu.disabled"
                >
                  <i :class="subMenu.icon" class="iconfont"></i>
                  <span slot="title">{{ subMenu.menuName }}</span>
                  <span class="msg_count" v-if="subMenu.msg_count">{{ subMenu.msg_count }}</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item v-else :key="index" :index="menu.index" @click="openUrl(menu.path)">
              <i :class="menu.icon"></i>
              <span slot="title">{{ menu.menuName }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </HorizontalToggle>
    <div v-if="screenWidth >= 850">
      <div class="sliderBar" v-if="sliderStatus">
        <span class="scale icon-menu" @click="changeSliderStatus"></span>
        <div class="trustlook_logo">
          <img src="../assets/img/logo-trustlook.png" alt="" />
        </div>
        <el-menu
          class="el-menu-vertical-demo"
          :default-active="onRoutes"
          background-color="#1f263e"
          active-text-color="#ff6500"
          @open="handleOpen"
          @close="handleClose"
          :default-openeds="openeds"
          :collapse="isCollapse"
          router
        >
          <template v-for="(menu, index) in menuData">
            <el-submenu v-if="menu.subMenu" :key="index" :index="menu.index">
              <template slot="title">
                <i :class="menu.icon"></i>
                <span class="menu-name">{{ menu.menuName }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  :key="subIndex"
                  :index="subMenu.index"
                  v-for="(subMenu, subIndex) in menu.subMenu"
                  @click="openUrl(subMenu.path)"
                  :disabled="subMenu.disabled"
                >
                  <i :class="subMenu.icon" class="iconfont"></i>
                  <span slot="title">{{ subMenu.menuName }}</span>
                  <span class="msg_count" v-if="subMenu.msg_count">{{ subMenu.msg_count }}</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item v-else :key="index" :index="menu.index" @click="openUrl(menu.path)">
              <i :class="menu.icon"></i>
              <span slot="title">{{ menu.menuName }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Vue from 'vue'
  import HorizontalToggle from './horizontalToggle.js'
  import VueRouter from 'vue-router'

  const { isNavigationFailure, NavigationFailureType } = VueRouter

  Vue.component(HorizontalToggle.name, HorizontalToggle)

  export default {
    name: 'SliderBar',
    data() {
      return {
        isCollapse: false,
        openeds: ['1', '2', '3'],
        screenWidth: document.documentElement.clientWidth || document.body.clientWidth,
        user: null
      }
    },
    computed: {
      ...mapState(['sliderStatus']),
      sliderStatus() {
        return this.$store.state.sliderStatus
      },
      onRoutes() {
        return this.$route.path.replace('/', '')
      },
      menuData() {
        const allMenuData = this.$t('menuData')
        // Filter menu items based on user permissions
        return allMenuData.map(menu => {
          if (menu.subMenu) {
            const filteredSubMenu = menu.subMenu.filter(subMenu => {
              // If menu item requires whitelist permission, check user.whitelist
              if (subMenu.requiresWhitelist) {
                return this.user && this.user.whitelist === true
              }
              return true
            })
            return {
              ...menu,
              subMenu: filteredSubMenu
            }
          }
          return menu
        })
      }
    },
    methods: {
      showMenu() {
        if (this.screenWidth > 850) {
          this.$store.commit('getSliderStatus', true)
        } else {
          this.$store.commit('getSliderStatus', false)
        }
      },
      handleResize(event) {
        this.screenWidth = document.documentElement.clientWidth
        this.showMenu()
      },
      handleOpen(key, keyPath) {
        // console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        // console.log(key, keyPath);
      },
      openUrl(url) {
        this.$router.push(url).catch(err => {
          // to hide the below error message
          if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
            throw Error(err)
          }
        })
        if (this.screenWidth < 850) {
          this.$store.commit('getSliderStatus', false)
        }
      },
      changeSliderStatus() {
        this.$store.commit('getSliderStatus', false)
      },
      getUserData: function() {
        const axios = require('axios')
        let self = this
        axios
          .get('/api/user')
          .then(response => {
            self.user = response.data
          })
          .catch(errors => {
            console.log('Error fetching user data in SliderBar:', errors)
          })
      }
    },
    created() {
      window.addEventListener('resize', this.handleResize)
      this.showMenu()
      this.getUserData()
    },
    beforeDestroy: function() {
      window.removeEventListener('resize', this.handleResize)
    }
  }
</script>
<style lang="scss" scoped>
  .sliderBar {
    .scale {
      display: none;
    }
  }
  .trustlook_logo {
    width: 168px;
    height: 39px;
    background-color: #1f263e;
    padding: 16px 74px 15px 25px;
    & > img {
      width: 100%;
      height: 100%;
    }
  }
  ::v-deep .el-menu-item.is-disabled {
    opacity: 1;
    cursor: not-allowed;
    background: 0 0 !important;
  }
  ::v-deep .el-submenu__icon-arrow {
    /*display: none;*/
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 267px;
    height: 100%;
    overflow: hidden;
    padding-bottom: 9999px;
    margin-bottom: -9999px;
  }
  .el-menu-item {
    width: 267px;
    font-size: 14px;
    height: 56px;
    text-align: left;
    padding-left: 24px !important;
    color: rgba(255, 255, 255, 0.5);
    box-sizing: border-box;
    font-family: Lato-Regular;
    font-weight: 400;
  }
  ::v-deep .el-icon-caret-right {
    color: $primary-color;
  }
  ::v-deep .el-menu-item-group__title {
    padding: 0 !important;
  }
  ::v-deep.el-menu-item.is-active {
    background-color: #303851 !important;
    position: relative;
    &:after {
      content: '';
      width: 0;
      height: 56px;
      border-left: 4px solid $primary-color;
      @include absolute-left-top(0, 0);
    }
  }
  ::v-deep .el-icon-caret-right {
    color: $primary-color;
    margin-right: 0 !important;
  }
  ::v-deep .el-submenu__title {
    font-size: 18px;
    text-align: left;
    padding-left: 23px !important;
    color: $white;
    font-family: Lato-Bold;
    font-weight: bold;
  }
  .iconfont {
    text-align: right;
    margin-right: 12px;
    font-size: 22px;
  }
  .msg_count {
    display: inline-block;
    width: 20px;
    height: 14px;
    text-align: center;
    line-height: 14px;
    background: $primary-color;
    @include border-radius(10px);
    color: #222;
    font-size: 8px;
    @include absolute-right-top(10px, 20px);
  }
  .menu-name {
    color: rgba(255, 255, 255, 0.8);
  }

  @media screen and (max-width: 850px) {
    .sliderBar {
      height: 100%;
      @include fixed-left-top(0, 0);
      z-index: 1999;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      .scale {
        display: block;
        @include fixed-left-top(300px, 0);
        width: 30px;
        text-align: center;
        height: 70px;
        line-height: 70px;
        cursor: pointer;
        color: #666;
        font-size: 14px;
      }
    }
  }
  @media screen and (max-width: 450px) {
    .sliderBar .scale {
      height: 50px;
      line-height: 50px;
      @include fixed-left-top(280px, 0);
    }
    .el-menu-vertical-demo:not(.el-menu--collapse) {
      min-height: calc(100% - 70px);
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SliderBar.vue